<template>
  <div class="sku-select-container">
    <div class="sku-select" id="skuSelect">
      <dl
        class="norm"
        v-for="(norm, index) in keys"
        :key="index"
        :data-type="norm"
        :data-idx="index"
      >
        <dt class="norm-name">
          <!-- <span>{{norm}}</span> -->
          {{norm}}
        </dt>
        <dd class="norm-values">
          <button
            class="norm-value"
            v-for="(normValue, index) in r.result[norm]"
            :key="index"
            :title="normValue"
            :value="normValue"
            :disabled="skuOriginData.disabled?skuOriginData.disabled:false"
            @click="onSelect"
          >{{normValue}}</button>
        </dd>
      </dl>
    </div>
    <div id="msg"></div>
  </div>
</template>

<script >
import $ from 'jquery';
const spliter = '\u2299';
export default {
  props: {
    skuOriginData: {
      type: Array,
      default() {
        return [
          { 颜色: '红', 尺码: '大', 型号: 'A', skuId: '3158055' },
          { 颜色: '白', 尺码: '大', 型号: 'A', skuId: '3158054' },
          { 颜色: '白', 尺码: '中', 型号: 'B', skuId: '3133859' },
          { 颜色: '蓝', 尺码: '小', 型号: 'C', skuId: '3516833' }
        ];
      }
    }
  },
  data() {
    return {
      res: {},
      r: {},
      keys: [],
      selectedCache: [],
    };
  },
  created() {

  },
  watch: {
    skuOriginData: function() {
      this.init(this.skuOriginData);
    }
  },
  methods: {
    // 计算组合数据
    combineAttr(data, keys) {
      let allKeys = [];
      let result = {};
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        let values = [];
        for (let j = 0; j < keys.length; j++) {
          let key = keys[j];
          if (!result[key]) result[key] = [];
          if (result[key].indexOf(item[key]) < 0) result[key].push(item[key]);
          values.push(item[key]);
        }
        allKeys.push({
          path: values.join(spliter),
          skuId: item['skuId']
        });
      }
      return {
        result: result,
        items: allKeys
      };
    },
    getAllKeys(arr) {
      // 根据 可选项列表得到可选描述
      let result = [];
      for (let i = 0; i < arr.length; i++) {
        result.push(arr[i].path);
      }
      return result;
    },
    powerset(arr) {
      // 输入一个正确组合，得到其所有的子集
      // console.log('powerset--输入数据源--', arr);
      let ps = [[]];
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0, len = ps.length; j < len; j++) {
          ps.push(ps[j].concat(arr[i]));
        }
      }
      // console.log('powerset--得到了什么', ps);
      return ps;
    },
    // 生成所有子集是否可选、库存状态 map
    buildResult(items) {
      // console.log('items是什么--', items);
      let allKeys = this.getAllKeys(items);
      for (let i = 0; i < allKeys.length; i++) {
        // 遍历正确组合，输出正确组合的所有子集
        let curr = allKeys[i];
        let sku = items[i].skuId;
        let values = curr.split(spliter);
        // console.log('当前可选项--', values);
        let allSets = this.powerset(values);
        // 每个组合的子集
        for (let j = 0; j < allSets.length; j++) {
          let set = allSets[j];
          let key = set.join(spliter);
          if (this.res[key]) {
            this.res[key].skus.push(sku);
          } else {
            this.res[key] = {
              skus: [sku]
            };
          }
        }
      }
    },
    trimSpliter(str, spliter) {
      // ⊙abc⊙ => abc
      // ⊙a⊙⊙b⊙c⊙ => a⊙b⊙c
      let reLeft = new RegExp('^' + spliter + '+', 'g');
      let reRight = new RegExp(spliter + '+$', 'g');
      let reSpliter = new RegExp(spliter + '+', 'g');
      let result = str
        .replace(reLeft, '')
        .replace(reRight, '')
        .replace(reSpliter, spliter);
      return result;
    },
    // 获取当前选中的属性
    getSelectedItem() {
      let result = [];
      $('dl[data-type]').each(function() {
        let $selected = $(this).find('.active');
        if ($selected.length) {
          result.push($selected.val());
        } else {
          result.push('');
        }
      });
      return result;
    },
    // 更新所有属性状态
    updateStatus(selected) {
      for (let i = 0; i < this.keys.length; i++) {
        let key = this.keys[i];
        let data = this.r.result[key];
        // let hasActive = !!selected[i];
        let copy = selected.slice();
        for (let j = 0; j < data.length; j++) {
          let item = data[j];
          if (selected[i] === item) continue;
          copy[i] = item;
          let curr = this.trimSpliter(copy.join(spliter), spliter);
          let $item = $('dl')
            .filter('[data-type="' + key + '"]')
            .find('[value="' + item + '"]');
          let titleStr = '[' + copy.join('-') + ']';
          if (this.res[curr]) {
            $item.removeClass('disabled');
            this.setTitle($item.get(0));
          } else {
            $item
              .addClass('disabled')
              .attr('title', titleStr + ' 无此属性搭配');
          }
        }
      }
    },
    // 正常属性点击
    handleNormalClick($this) {
      $this.siblings().removeClass('active');
      $this.addClass('active');
    },
    // 无效属性点击
    handleDisableClick($this) {
      let $currAttr = $this.parents('dl').eq(0);
      let idx = $currAttr.data('idx');
      let type = $currAttr.data('type');
      let value = $this.val();
      $this.removeClass('disabled');
      this.selectedCache[idx] = value;
      // 清空高亮行的已选属性状态（因为更新的时候默认会跳过已选状态）
      $('dl')
        .not($currAttr)
        .find('button')
        .removeClass('active');
      this.updateStatus(this.getSelectedItem());
      /**
       * 恢复原来已选属性
       * 遍历所有非当前属性行
       *   1. 与 selectedCache 对比
       *   2. 如果要恢复的属性存在（非 disable）且 和当前*未高亮行*已选择属性的*可组合*），高亮原来已选择的属性且更新
       *   3. 否则什么也不做
       */
      for (let i = 0; i < this.keys.length; i++) {
        let item = this.keys[i];
        let $curr = $('dl[data-type="' + item + '"]');
        if (item === type) continue;
        let $lastSelected = $curr.find(
          'button[value="' + this.selectedCache[i] + '"]'
        );
        // 缓存的已选属性没有 disabled (可以被选择)
        if (!$lastSelected.hasClass('disabled')) {
          $lastSelected.addClass('active');
          this.updateStatus(this.getSelectedItem());
        }
      }
    },
    // 高亮当前属性区
    highLighAttr() {
      for (let i = 0; i < this.keys.length; i++) {
        let key = this.keys[i];
        let $curr = $('dl[data-type="' + key + '"]');
        if ($curr.find('.active').length < 1) {
          $curr.addClass('hl');
        } else {
          $curr.removeClass('hl');
        }
      }
    },
    onSelect(e) {
      let ele = e.target;
      let $this = $(ele);
      let isActive = $this.hasClass('.active');
      let isDisable = $this.hasClass('disabled');
      if (!isActive) {
        this.handleNormalClick($this);
        if (isDisable) {
          this.handleDisableClick($this);
        } else {
          let index = $this
            .parents('dl')
            .eq(0)
            .data('idx');
          this.selectedCache[index] = $this.val();
        }
        this.updateStatus(this.getSelectedItem());
        this.highLighAttr();
        this.showResult();
      }
    },
    bindEvent() {
      $('button').each((index, ele) => {
        let value = $(ele).val();
        if (!this.res[value] && !$(ele).hasClass('active')) {
          $(ele).addClass('disabled');
        }
      });
    },
    // 展示已选择的结果
    showResult() {
      let result = this.getSelectedItem();
      let s = [];
      for (let i = 0; i < result.length; i++) {
        let item = result[i];
        if (item) {
          s.push(item);
        }
      }
      if (s.length === this.keys.length) {
        let curr = this.res[s.join(spliter)];
        if (curr) {
          s = s.concat(curr.skus);
        }
        // 这里将数据传给父组件
        this.$emit('has-select-sku', s);
      }
    },
    setTitle(el) {
      let title = $(el).data('title');
      if (title) $(el).attr('title', title);
    },
    setAllTitle() {
      $('#skuSelect')
        .find('button')
        .each(this.setTitle);
    },
    // 初始化
    init(data) {
      for (let attrKey in data[0]) {
        if (!data[0].hasOwnProperty(attrKey)) continue;
        if (attrKey !== 'skuId') this.keys.push(attrKey);
      }
      this.setAllTitle();
      this.r = this.combineAttr(data, this.keys);
      this.buildResult(this.r.items);
      this.updateStatus(this.getSelectedItem());
      this.showResult();
      this.bindEvent();
      
      /* 以下是默认选择第一个sku */
      this.$nextTick(() => {
        let normVal = document.getElementsByClassName('norm-values')
        for (let i = 0; i < normVal.length; i++) {
          let $this = $(normVal[i].firstElementChild)
          $this.siblings().removeClass('active');
          $this.addClass('active');
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.sku-select-container {
  .norm {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    min-height: 40px;
    .norm-name {
      width: 60px;
      padding-right: 10px;
      font-size: 12px;
      color: #606266;
      letter-spacing: 2px;
      display: flex;
      align-items: center;
      height: 32px;
      line-height: 14px;
      /* span {
        width: 60px;
        display: inline-block;
        text-align: justify;
        line-height: 14px;
      }
      span:after {
        content: "";
        display: inline-block;
        width: 100%;
        max-height: 0;
      } */
    }

    .norm-values {
      width: 600px;
      .norm-value {
        height: 32px;
        margin: 0px 8px 12px 0;
        border: 1px solid #979797;
        background: #fff;
        color: #606266;
        letter-spacing: 1px;
        line-height: 24px;
        padding: 0 8px;
        border-radius: 2px;
        font-size: 12px;
        max-width: 130px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &.active {
          border: 2px solid #df3445;
          padding: 0 7px;
        }
        &.disabled {
          color: #606266;
          border: 2px dashed rgba(151, 151, 151, 1);
        }
      }
    }
  }
}
</style>
